import type { TaskRecord } from "@nexus/contracts";

const PERSONA_OPPORTUNITY_SETS_PAGE = "persona-opportunity-sets";

export function isPersonaOpportunitySetsPage(
  task: Pick<TaskRecord, "navigation">,
): boolean {
  return task.navigation?.page === PERSONA_OPPORTUNITY_SETS_PAGE;
}

export function isPersonaSetGenerationTask(
  task: Pick<TaskRecord, "type" | "navigation">,
): boolean {
  if (task.type === "generate-persona-opportunity-set") return true;
  return task.type === "generate-opportunity-set" && isPersonaOpportunitySetsPage(task);
}

/**
 * Persona and competitor scratch jobs poll through the persona scripts mutation.
 * Leftover Opportunities `generate-scripts` cards use a different poll and must
 * not receive the persona cancel toast.
 */
export function cancelsPersonaScriptsPoll(
  task: Pick<TaskRecord, "type" | "navigation">,
): boolean {
  if (task.type === "generate-persona-scripts") return true;
  return task.type === "generate-scripts" && isPersonaOpportunitySetsPage(task);
}

export function isLeftoverSetGenerationTask(
  task: Pick<TaskRecord, "type" | "navigation">,
): boolean {
  return task.type === "generate-opportunity-set" && !isPersonaOpportunitySetsPage(task);
}
